import { Check, Loader2, Play } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { hoverLabel } from "@/lib/format";
import { tiltFor } from "@/lib/themes";
import { isGuest } from "@/lib/guest";
import { CellHeart } from "@/components/library/Hearts";
import { ThumbImg } from "./ThumbImg";

export const PhotoCell = ({ item, area, selecting, selected, onOpen, onToggle }) => {
  const processing = item.status === "queued" || item.status === "processing";
  const label = hoverLabel(item);
  const click = () => (selecting ? onToggle(item.id) : onOpen(item.id));
  const video = item.media_type === "video";
  const placeholder = <span className="video-placeholder" data-testid={`video-placeholder-${item.id}`}><span className="vp-icon"><Play size={18} /></span></span>;
  return (
    <button
      type="button"
      className={`book-cell ${selected ? "is-selected" : ""}`}
      style={{ gridArea: area, "--tilt": tiltFor(item.id) }}
      onClick={click}
      data-testid={`photo-card-${item.id}`}
    >
      {item.thumb_url ? (
        <ThumbImg src={mediaUrl(item.thumb_url)} fallback={video ? placeholder : null} />
      ) : video && !processing ? placeholder : (
        <span className="book-cell-processing" data-testid={`photo-processing-${item.id}`}>
          <Loader2 className="animate-spin" size={18} />
        </span>
      )}
      {item.file_unavailable && <span className="book-cell-unavailable" data-testid={`file-unavailable-${item.id}`}>File unavailable</span>}
      <span className="pc-deco" aria-hidden="true" />
      {item.media_type === "video" && !processing && (
        <span className="book-cell-video"><Play size={12} fill="currentColor" /></span>
      )}
      {label && !selecting && <span className="book-cell-hover" data-testid={`photo-hover-${item.id}`}>{label}</span>}
      {isGuest() && !selecting && <CellHeart id={item.id} />}
      {selecting && (
        <span className={`book-cell-check ${selected ? "on" : ""}`} data-testid={`photo-checkbox-${item.id}`}>
          {selected && <Check size={12} strokeWidth={3} />}
        </span>
      )}
    </button>
  );
};
